import { render, staticRenderFns } from "./friendRequest.vue?vue&type=template&id=f2b58720&scoped=true&lang=pug&"
import script from "./friendRequest.vue?vue&type=script&lang=js&"
export * from "./friendRequest.vue?vue&type=script&lang=js&"
import style0 from "./friendRequest.vue?vue&type=style&index=0&id=f2b58720&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2b58720",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2b58720')) {
      api.createRecord('f2b58720', component.options)
    } else {
      api.reload('f2b58720', component.options)
    }
    module.hot.accept("./friendRequest.vue?vue&type=template&id=f2b58720&scoped=true&lang=pug&", function () {
      api.rerender('f2b58720', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/friend/friendRequest.vue"
export default component.exports